import React from 'react';

export declare type FocusType = 'false' | 'true';

export type IconProps = {
  className?: string;
  color?: string;
  focusable?: FocusType;
  height?: number;
  onClick?: () => void;
  size?: number;
  width?: number;
};

export const Lock: React.FC<IconProps & JSX.IntrinsicElements['svg']> = ({
  className = '',
  color = '#090C33',
  focusable = 'false',
  height,
  onClick,
  size = 24,
  width,
  ...rest
}) => {
  const iconColor = undefined;

  return (
    <svg
      fill="none"
      height={height || size}
      width={width || size}
      onClick={onClick}
      className={className}
      focusable={focusable}
      {...rest}
      viewBox="0 0 24 28"
    >
      <path
        stroke={iconColor || color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17 8a4.95 4.95 0 00-4.9-5H12a4.95 4.95 0 00-5 4.9V13m-4 0h18v12H3V13zm11 6a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  );
};
